import { render, staticRenderFns } from "./UpdateClientCredit.vue?vue&type=template&id=66f196d5&"
import script from "./UpdateClientCredit.vue?vue&type=script&lang=js&"
export * from "./UpdateClientCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports